
<!-- <router-outlet></rout/er-outlet> -->
  <div class="m-0 p-0 " id="mainC">
    <app-docs-mobi></app-docs-mobi>
</div>